import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

// Styles
import styles from './Panel.module.scss'

const Panel = ({ className, children }) => {
  return <div className={classnames(styles.panel, className)}>{children}</div>
}

Panel.propTypes = {
  className: PropTypes.string,
  children: PropTypes.any,
}

export default Panel
